/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HazardFactorDto } from '../../models/hazard-factor-dto';

export interface GetHazardFactors$Params {

/**
 * The customer id
 */
  customerId: number;

/**
 * The risk assessment id which contains the hazard factors
 */
  riskAssessmentId: number;
}

export function getHazardFactors(http: HttpClient, rootUrl: string, params: GetHazardFactors$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HazardFactorDto>>> {
  const rb = new RequestBuilder(rootUrl, getHazardFactors.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.query('riskAssessmentId', params.riskAssessmentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HazardFactorDto>>;
    })
  );
}

getHazardFactors.PATH = '/customers/{customerId}/hazard-factors';
